import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { AppTokenService } from "./app-token.service";
import { HttpHandlerService } from "./http-handler.service";
@Injectable()

export class CompanyService {
    _httpHandler: HttpHandlerService;
    _apiUrl = environment.apiUrl;
    _getAllEndPoint = 'companies';
    _getAllListEndPoint = 'companies/list';
    _addEndPoint = 'companies'
    _updateEndPoint = 'companies';
    _getByIdEndPoint = 'companies/';
    _deleteEndPoint = 'companies/';

    constructor(private httpHandler: HttpHandlerService, private appTokenService: AppTokenService) {
        this._httpHandler = httpHandler;
    }

    public GetAll(params?: any): Observable<any> {
        let full_api_url = `${this._apiUrl}${this._getAllEndPoint}?isactive=${params?.isactive}`
        if (params?.scid) {
            full_api_url = full_api_url + `&sc=${params?.scid}`;
        }
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetAllList(params?: any): Observable<any> {
        let full_api_url = `${this._apiUrl}${this._getAllListEndPoint}?pagelimit=${params?.length}&pageoffset=${params?.start}`
        if (params?.refresh) {
            full_api_url = full_api_url + `refresh=${new Date().getTime()}`;
        }
        
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );

        // console.log('tokenizedResponse', this.appTokenService.tokenizedResponse);
        
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetById(companyId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getByIdEndPoint}${companyId}?refresh=${new Date().getTime()}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }
    
    public Add(companyData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._addEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            companyData
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public Update(companyData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._updateEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            companyData
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public Delete(companyId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._deleteEndPoint}${companyId}`;
        const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public GetAllFinancialYearByCompanyId(companyId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllEndPoint}/${companyId}/financialyear`;
        const request_option = this._httpHandler.prepareRequest('GET', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }
    public GetFinancialYearById(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._deleteEndPoint}/financialyear/${id}`;
        const request_option = this._httpHandler.prepareRequest('GET', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }
    public AddFinancialYear(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._addEndPoint}/financialyear`;
        const request_option = this._httpHandler.prepareRequest('POST', full_api_url, data);
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }
    public UpdateFinancialYear(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._updateEndPoint}/financialyear`;
        const request_option = this._httpHandler.prepareRequest('PUT', full_api_url, data);
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }
    
    public DeleteFinancialYearById(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._deleteEndPoint}financialyear/${id}`;
        const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

}



